/**
 * Contact Service
 * Handles contact form submissions
 */
import apiService from './api';

class ContactService {
  constructor() {
    this.api = apiService;
  }

  /**
   * Submit a contact message
   * @param {Object} messageData - Contact message data
   * @returns {Promise} Submission response
   */
  async submitMessage(messageData) {
    return this.api.request('/contact', {
      method: 'POST',
      body: JSON.stringify(messageData)
    });
  }
}

const contactService = new ContactService();
export default contactService;
